import { ComponentProps, FC } from 'react'
import { styled } from '../../../../lib/stitches'
import { Row } from '../../../core/Components'
import { gray14, MINTABLE_COLORS } from '../../../platform/color'

const ColorCircle = styled('div', {
  height: '15px',
  width: '15px',
  borderRadius: '50%',
  marginRight: '5px',
  border: '2px solid inherit',
  transition: '100ms',
  opacity: '60%',
  '&:hover': {
    border: `2px solid ${gray14}`,
    cursor: 'pointer'
  },
  variants: {
    active: {
      true: {
        border: `2px solid ${gray14}`,
        opacity: '100%'
      }
    },
    disabled: {
      true: {
        '&:hover': {
          border: '2px solid transparent',
          cursor: 'not-allowed'
        }
      }
    }
  }
})

interface ColorPickerProps {
  onPick: (newColor: string) => void
  currentColor: string
  isDisabled?: boolean
}

const ColorPicker: FC<ColorPickerProps & ComponentProps<typeof Row>> = ({
  onPick,
  currentColor,
  isDisabled,
  ...props
}) => {
  return (
    <Row verticalCenter {...props}>
      {MINTABLE_COLORS.map((color) => (
        <ColorCircle
          css={{ backgroundColor: color }}
          active={currentColor === color}
          onClick={isDisabled ? null : () => onPick(color)}
          key={color}
          disabled={isDisabled}
        />
      ))}
    </Row>
  )
}

export default ColorPicker
